export const GENDERS = [
    { key: 'WOMEN', label: 'Women' },
    { key: 'MEN', label: 'Men' },
    { key: 'UNISEX', label: 'Unisex' },
    { key: 'CHILDREN', label: 'Children' },
];
